<template>
  <div>
    <div class="row">
      <div class="col-8">
        <idx-card
          :title="`${this.$t('menu.settings.alertsNewsletters.titleNewRule')}`"
        >
          <new-rule />
          <div class="text-right mt-2">
            <button
              @click="registerRule"
              class="btn btn-primary mt-4"
              :disabled="loading"
            >
              {{ $t('menu.settings.alertsNewsletters.buttonRegister') }}
            </button>
          </div>
        </idx-card>
      </div>
      <div class="col-4">
        <table-rules />
      </div>
    </div>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import EventBus from '../../../../eventBus';
import newRule from './new-rule';
import tableRules from './table-rules';

export default {
  name: 'SettingsRules',

  components: {
    IdxCard,
    newRule,
    tableRules,
  },

  mounted() {
    EventBus.$on('loadingNewRule', () => {
      this.loading = false;
    });
  },

  data: () => ({
    loading: false,
  }),

  methods: {
    registerRule() {
      this.loading = true;
      EventBus.$emit('registerNewRule');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/index.vue